<div class="preferences-confirmed-page-wrapper">
  <app-web-style-top-bar [pageTitle]="pageTitle"></app-web-style-top-bar>
  <div class="confirmation-text">{{"thank-you" | translate }}</div>
</div>
